/* Tabs.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJZeqy%7Bgrid-area%3Atabs%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2YLqiKQRM5%7Bmargin-inline%3Avar(--ds-space-negative-300%2C-24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._43nrzT2ADO%7Bmargin-block-start%3Avar(--ds-space-100%2C8px)%7D");
import React from 'react';
import LegacyBox from '@atlaskit/primitives/box';
import { Box as CompiledBox } from '@atlaskit/primitives/compiled/box';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { fg } from '@townsquare/stat-sig/gate';
const styles = xcss({
  marginBlockStart: 'space.100',
  marginInline: 'space.negative.300',
  /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles */
  // @ts-expect-error - Remove bottom border on platform tabs via nested style as there's no other way to do this currently
  'nav::before': {
    display: 'none'
  }
  /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles */
});
const compiledWrapperStyles = {
  root: "_1xC2CJZeqy _4bt5LAnQyn _2WAcuGnQyn"
};
const compiledInnerStyles = {
  root: "_2YLqiKQRM5 _43nrzT2ADO"
};
export const Tabs = ({
  children
}: React.PropsWithChildren<unknown>): React.JSX.Element => {
  return <CompiledBox xcss={compiledWrapperStyles.root}>
			{fg('townsquare-compiled-xcss-to-cssmap-final') ? <CompiledBox xcss={compiledInnerStyles.root}>{children}</CompiledBox> : <LegacyBox xcss={styles}>{children}</LegacyBox>}
		</CompiledBox>;
};